if (module.hot) {
    module.hot.accept();
}
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import axios from "./utils/httpAxios.js";
import Cookie from "js-cookie";
import "lib-flexible";
import "./utils/setWxFontSize";
import covert from './utils/covert';
import moment from 'moment'

import CusField from './components/common/Field'
import CusCell from './components/common/Cell'
import {ImagePreview, TreeSelect} from 'vant'

Vue.use(CusField)
    .use(CusCell)

import {
    Button,
    Collapse,
    CollapseItem,
    Checkbox,
    CheckboxGroup,
    Icon,
    Field,
    Popup,
    Picker,
    ActionSheet,
    Tab,
    Tabs,
    Cell,
    CellGroup,
    Panel,
    Search,
    PullRefresh,
    List,
    RadioGroup,
    Radio,
    AddressEdit,
    Uploader,
    Area,
    Row,
    Col,
    DatetimePicker,
    Steps,
    Step,
    Rate,
    Dialog,
    NoticeBar,
    Toast,
    Tag,
    Calendar
} from "vant";

Vue.use(VueClipboard)
    .use(Button)
    .use(Collapse)
    .use(CollapseItem)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Icon)
    .use(Field)
    .use(Popup)
    .use(Picker)
    .use(ActionSheet)
    .use(Tab)
    .use(Tabs)
    .use(Cell)
    .use(CellGroup)
    .use(Panel)
    .use(Search)
    .use(PullRefresh)
    .use(List)
    .use(Radio)
    .use(RadioGroup)
    .use(AddressEdit)
    .use(Uploader)
    .use(Area)
    .use(Row)
    .use(Col)
    .use(DatetimePicker)
    .use(Step)
    .use(Steps)
    .use(Rate)
    .use(Toast)
    .use(Dialog)
    .use(NoticeBar)
    .use(ImagePreview)
    .use(TreeSelect)
    .use(Tag)
    .use(Calendar);


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$cookie = Cookie;
Vue.prototype.$logisticsCompanyId = 'ac9b3a1c5a454a8cb589b8a4a0c4dea1'
Vue.prototype.$logisticsCompanyName = '柯莱顺发铁马'
Vue.prototype.$wechatMark = 'kelai'
Vue.prototype.$loginType = 5
Vue.prototype.$callbackPage = 'https://kl.cg1717.com/preOrder'
Vue.prototype.$covert = covert
window.$moment = moment
Vue.prototype.$isIosOrAndroid = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    let isStr = "";
    if (isAndroid) {
        isStr = "android";
    }
    if (isiOS) {
        isStr = "ios";
    }
    return isStr;
};

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");


